var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-row',{staticStyle:{"margin-top":"50vh","font-size":"20px"}},[_c('el-col',{staticClass:"tip-content",staticStyle:{"height":"100px","background-color":"gainsboro"},attrs:{"span":14,"offset":6}},[_c('div',{staticStyle:{"text-align":"center","font-size":"3rem"}},[_vm._v("\n      功能开发中，暂不支持手机端\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }